export default __webpack_public_path__ + "static/media/blog-img.60662687.png";